// @flow
import types from './categoryConstants';
import { deleteAsync, getAsync, patchAsync, postAsync } from '../../../../_metronic/helpers/httpClient';

export const clearState = () => async dispatch => {
    dispatch({
        type: types.CLEAR_STATE
    })
}

export const getCategoryList = (keyword = '') => async dispatch => {

    dispatch({
        type: types.GET_CATEGORIES
    })

    const response = await getAsync(`/categories?keyword=${keyword}`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_CATEGORIES_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.GET_CATEGORIES_FAILED,
            payload: response,
        })
    }
}

export const getCategory = (id) => async dispatch => {
    dispatch({
        type: types.GET_CATEGORY
    })

    const response = await getAsync(`/categories/${id}`);

    if (response.isSuccess) {
        dispatch({
            type: types.GET_CATEGORY_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.GET_CATEGORY_FAILED,
            payload: response,
        })
    }
}

export const postCategory = (category) => async dispatch => {
    dispatch({
        type: types.POST_CATEGORY
    })

    const response = await postAsync(`/categories`, category);

    if (response.isSuccess) {
        dispatch({
            type: types.POST_CATEGORY_SUCCESS,
            payload: response.data,
        })
    } else {
        dispatch({
            type: types.POST_CATEGORY_FAILED,
            payload: response,
        })
    }
}

export const patchCategory = (id, category) => async dispatch => {
    dispatch({
        type: types.PATCH_CATEGORY
    })

    const response = await patchAsync(`/categories/${id}`, category);

    if (response.isSuccess) {
        dispatch({
            type: types.PATCH_CATEGORY_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.PATCH_CATEGORY_FAILED,
            payload: response,
        })
    }
}

export const deleteCategory = (id) => async dispatch => {
    dispatch({
        type: types.DELETE_CATEGORY
    })

    const response = await deleteAsync(`/categories/${id}`);

    if (response.isSuccess) {
        dispatch(getCategoryList())
        dispatch({
            type: types.DELETE_CATEGORY_SUCCESS,
            payload: response,
        })
    } else {
        dispatch({
            type: types.DELETE_CATEGORY_FAILED,
            payload: response,
        })
    }
}
